import React, { useEffect, useRef } from 'react';
import logo from '../../assets/branding/lbcc-branco.png';
import './CollaboratorIntro.css';

const particles = Array.from({ length: 54 }, (_, i) => ({
  '--x': `${((i * 73 + 19) % 101)}%`,
  '--y': `${((i * 37 + 11) % 97)}%`,
  '--delay': `${(i % 9) * 55}ms`,
  '--size': `${i % 5 === 0 ? 3 : 2}px`,
  '--drift': `${(i % 2 ? 1 : -1) * (30 + i % 60)}px`,
}));

export default function CollaboratorIntro({ onComplete }) {
  const complete = useRef(onComplete);
  complete.current = onComplete;
  const finished = useRef(false);
  const dialog = useRef(null);

  useEffect(() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.current?.focus({ preventScroll: true });
    const timer = window.setTimeout(() => {
      if (!finished.current) {
        finished.current = true;
        complete.current();
      }
    }, reduced.matches ? 350 : 3000);
    const handleKey = (event) => {
      if (event.key === 'Tab') { event.preventDefault(); dialog.current?.focus(); }
    };
    window.addEventListener('keydown', handleKey);
    return () => {
      window.clearTimeout(timer);
      window.removeEventListener('keydown', handleKey);
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  return (
    <div ref={dialog} tabIndex={-1} className="collaborator-intro" role="dialog" aria-modal="true" aria-label="Bem-vindo ao portal do colaborador" data-testid="collaborator-intro">
      <div className="collaborator-intro__scene" aria-hidden="true">
        <div className="collaborator-intro__glow" />
        <div className="collaborator-intro__horizon" />
        <div className="collaborator-intro__orbit" />
        <div className="collaborator-intro__particles">
          {particles.map((style, i) => <i key={i} style={style} />)}
        </div>
      </div>
      <div className="collaborator-intro__brand">
        <div className="collaborator-intro__emblem"><img src={logo} alt="LBCC" /></div>
        <div className="collaborator-intro__wordmark">LBCCorex <span>HUB</span></div>
        <p>PORTAL DO COLABORADOR</p>
        <div className="collaborator-intro__line" aria-hidden="true" />
      </div>
    </div>
  );
}
